import { createContext } from 'react';
import { AppContextInterface } from '../../types';

export const ApplicationContext = createContext<AppContextInterface | undefined>(undefined);
